// Stricter than HTML5 type=email: requires at least one dot in the domain
// (rejects "user@localhost"), so a real typo like "user@gmial" gets caught
// before we wire it up to a reset-password send.
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function isValidEmail(value) {
  if (typeof value !== 'string') return false;
  return EMAIL_RE.test(value);
}
